import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const InspectionsPageLink = () => {

  return (
    <AsideMenuLink
      pathname={P.INSPECTIONS_PAGE}
      subject={S.INSPECTIONS_PAGE}
      icon={'Clipboard_navy.svg'}
      label={<FormattedMessage id="inspections-page-link" defaultMessage="Inspections page"/>}
    />
  );
};

export default InspectionsPageLink;
